import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const RegisterPage = () => {
  const [login, setLogin] = useState("");
  const [fullname, setName] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [acceptedLicense, setAcceptedLicense] = useState(false);
  const [licenseOpen, setLicenseOpen] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("registerData");
    if (saved) {
      const data = JSON.parse(saved);
      setLogin(data.login || "");
      setName(data.fullname || "");
      setPassword(data.password || "");
      setEmail(data.email || "");
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!acceptedLicense) {
      setError("Вы должны принять лицензионное соглашение");
      return;
    }

    if (password !== confirmPassword) {
      setError("Пароли не совпадают");
      return;
    }

    // сохраняем данные во временное хранилище
    localStorage.setItem("registerData", JSON.stringify({
      login,
      fullname,
      password,
      email
    }));

    navigate("/register/details");
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundImage: `url('/background.jpg')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        padding: "20px",
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          backgroundColor: "rgba(0,0,0,0.85)",
          padding: "40px 30px",
          borderRadius: "16px",
          maxWidth: "400px",
          width: "100%",
          boxShadow: "0 8px 30px rgba(0,0,0,0.85)",
          color: "#fff",
        }}
      >
        <h2 style={{ textAlign: "center", marginBottom: "25px", fontSize: "26px" }}>
          🪂 Регистрация
        </h2>

        <div style={{ marginBottom: "20px" }}>
          <label style={{ display: "block", marginBottom: "6px", fontWeight: "bold" }}>
            Логин
          </label>
          <input
            type="text"
            value={login}
            onChange={(e) => setLogin(e.target.value)}
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: "10px",
              border: "1.5px solid #444",
              backgroundColor: "#1a1a1a",
              color: "#eee",
              fontSize: "15px",
              boxShadow: "inset 0 0 6px #000000cc",
              outline: "none",
              boxSizing: "border-box"
            }}
            required
          />
        </div>

        <div style={{ marginBottom: "20px" }}>
          <label style={{ display: "block", marginBottom: "6px", fontWeight: "bold" }}>
            Имя пользователя
          </label>
          <input
            type="text"
            value={fullname}
            onChange={(e) => setName(e.target.value)}
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: "10px",
              border: "1.5px solid #444",
              backgroundColor: "#1a1a1a",
              color: "#eee",
              fontSize: "15px",
              boxShadow: "inset 0 0 6px #000000cc",
              outline: "none",
              boxSizing: "border-box"
            }}
            required
          />
        </div>

        <div style={{ marginBottom: "20px" }}>
          <label style={{ display: "block", marginBottom: "6px", fontWeight: "bold" }}>
            Пароль
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: "10px",
              border: "1.5px solid #444",
              backgroundColor: "#1a1a1a",
              color: "#eee",
              fontSize: "15px",
              boxShadow: "inset 0 0 6px #000000cc",
              outline: "none",
              boxSizing: "border-box"
            }}
            required
          />
        </div>

        <div style={{ marginBottom: "25px" }}>
          <label style={{ display: "block", marginBottom: "6px", fontWeight: "bold" }}>
            Подтвердите пароль
          </label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: "10px",
              border: "1.5px solid #444",
              backgroundColor: "#1a1a1a",
              color: "#eee",
              fontSize: "15px",
              boxShadow: "inset 0 0 6px #000000cc",
              outline: "none",
              boxSizing: "border-box"
            }}
            required
          />
        </div>

        <div style={{ marginBottom: "25px" }}>
          <label style={{ display: "block", marginBottom: "6px", fontWeight: "bold" }}>
            Подтвердите E-Mail
          </label>
          <input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: "10px",
              border: "1.5px solid #444",
              backgroundColor: "#1a1a1a",
              color: "#eee",
              fontSize: "15px",
              boxShadow: "inset 0 0 6px #000000cc",
              outline: "none",
              boxSizing: "border-box"
            }}
            required
          />
        </div>

        {error && (
          <div style={{ color: "#FF6B6B", marginBottom: "15px", textAlign: "center" }}>
            {error}
          </div>
        )}

        <div style={{
          marginBottom: "20px",
          display: "flex",
          alignItems: "flex-start",
          gap: "10px",
        }}>
          <input
            type="checkbox"
            checked={acceptedLicense}
            onChange={(e) => setAcceptedLicense(e.target.checked)}
            style={{
              marginTop: "4px",
              transform: "scale(1.2)",
              cursor: "pointer"
            }}
          />

          <div style={{ fontSize: "14px", lineHeight: "1.4" }}>
            Ознакомлен и принимаю{" "}
            <span
              onClick={() => setLicenseOpen(true)}
              style={{
                color: "#FFD700",
                textDecoration: "underline",
                cursor: "pointer"
              }}
            >
              лицензионное соглашение
            </span>
          </div>
        </div>

        <button
          type="submit"
          disabled={loading}
          style={{
            width: "100%",
            backgroundColor: "#FFD700",
            color: "#000",
            padding: "14px",
            fontSize: "16px",
            fontWeight: "bold",
            border: "none",
            borderRadius: "8px",
            cursor: loading ? "not-allowed" : "pointer",
            transition: "background 0.3s",
            marginBottom: "10px",
          }}
        >
          {loading ? "Регистрация..." : "Продолжить"}
        </button>

        <button
          type="button"
          onClick={() => navigate("/login")}
          style={{
            width: "100%",
            backgroundColor: "#444",
            color: "#fff",
            padding: "14px",
            fontSize: "16px",
            fontWeight: "bold",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            transition: "background 0.3s",
          }}
        >
          ⬅️ На страницу входа
        </button>
      </form>

      {licenseOpen && (
        <div
          onClick={() => setLicenseOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "rgba(0,0,0,0.95)",
              padding: "25px",
              borderRadius: "12px",
              maxWidth: "600px",
              width: "90%",
              maxHeight: "80vh",
              overflowY: "auto",
              color: "#fff",
              boxShadow: "0 10px 40px rgba(0,0,0,0.9)",
              fontSize: "14px",
              lineHeight: "1.6"
            }}
          >

            <h2 style={{ marginBottom: "15px" }}>Лицензионное соглашение</h2>

            <p>
              Настоящее Лицензионное соглашение (далее — «Соглашение») регулирует отношения между владельцем веб-сайта (далее — «Администрация») и пользователем (далее — «Пользователь») при использовании данного интернет-ресурса.
              <br /><br />
              Используя сайт, проходя регистрацию или продолжая использование сервиса, Пользователь подтверждает, что ознакомился с условиями настоящего Соглашения, понимает их и принимает в полном объеме.
            </p>

            <h3 style={{ marginTop: "20px", marginBottom: "10px", color: "#FFD700" }}>1. Общие положения</h3>
            <ul style={{ paddingLeft: "18px" }}>
              <li>1.1.  Сайт представляет собой информационный сервис, предназначенный для ведения и отображения пользовательских данных, связанных с парашютной деятельностью (включая, но не ограничиваясь: количество прыжков, параметры прыжков, используемое оборудование и иные данные).</li>
              <li>1.2.  Сайт не является официальным источником информации и не подтверждает достоверность, квалификацию, опыт или уровень подготовки Пользователей.</li>
              <li>1.3.  Любая информация, размещенная на сайте, носит исключительно справочный и пользовательский характер.</li>
            </ul>

            <h3 style={{ marginTop: "20px", marginBottom: "10px", color: "#FFD700" }}>2. Регистрация и учетная запись</h3>
            <ul style={{ paddingLeft: "18px" }}>
              <li>2.1. Для доступа к полному функционалу сайта Пользователь проходит процедуру регистрации.</li>
              <li>2.2. Пользователь обязуется предоставлять достоверную и актуальную информацию при регистрации и использовании сервиса.</li>
              <li>2.3. Пользователь несет полную ответственность за сохранность своих учетных данных и за все действия, совершенные под его учетной записью.</li>
            </ul>

            <h3 style={{ marginTop: "20px", marginBottom: "10px", color: "#FFD700" }}>3. Пользовательский контент</h3>
            <ul style={{ paddingLeft: "18px" }}>
              <li>3.1. Пользователь самостоятельно и добровольно размещает на сайте любые данные, включая текстовую информацию, статистику, изображения и иные материалы.</li>
              <li>3.2. Размещая контент, Пользователь:
                <ul>
                  <li>подтверждает, что обладает всеми необходимыми правами на размещаемые материалы;</li>
                  <li>дает согласие на обработку, хранение и отображение данных на сайте;</li>
                  <li>соглашается с тем, что размещенные данные могут быть доступны другим пользователям сайта.</li>
                </ul>
              </li>
              <li>3.3. Пользователь понимает и соглашается, что:
                <ul>
                  <li>все данные публикуются им добровольно;</li>
                  <li>данные могут быть просмотрены третьими лицами;</li>
                  <li>удаление данных может быть ограничено техническими особенностями сервиса.</li>
                </ul>

              </li>
            </ul>

            <h3 style={{ marginTop: "20px", marginBottom: "10px", color: "#FFD700" }}>4. Ограничение ответственности</h3>
            <ul style={{ paddingLeft: "18px" }}>
              <li>4.1. Администрация не проверяет достоверность информации, размещаемой Пользователями, и не несет ответственности за ее точность, полноту или актуальность.</li>
              <li>4.2. Сайт не подтверждает:
                <ul>
                  <li>количество прыжков;</li>
                  <li>опыт пользователя;</li>
                  <li>квалификацию или уровень подготовки.</li>
                </ul>

              </li>
              <li>4.3. Пользователь использует информацию сайта на свой страх и риск.</li>
              <li>4.4. Администрация не несет ответственности за:
                <ul>
                  <li>любые убытки или последствия, возникшие в результате использования сайта;</li>
                  <li>действия пользователей на основе размещенной информации.</li>
                </ul>

              </li>
            </ul>

            <h3 style={{ marginTop: "20px", marginBottom: "10px", color: "#FFD700" }}>5. Соблюдение законодательства</h3>
            <ul style={{ paddingLeft: "18px" }}>
              <li>5.1. Пользователь обязуется не размещать информацию и материалы, которые:
                <ul>
                  <li>нарушают законодательство Российской Федерации;</li>
                  <li>содержат запрещенный контент;</li>
                  <li>нарушают права третьих лиц;</li>
                  <li>являются ложными, вводящими в заблуждение или оскорбительными.</li>
                </ul>

              </li>
              <li>5.2. Пользователь самостоятельно несет ответственность за:
                <ul>
                  <li>законность размещаемых данных;</li>
                  <li>соответствие информации требованиям законодательства РФ.</li>
                </ul>

              </li>
              <li>5.3. Администрация не несет ответственности за пользовательский контент, но вправе реагировать на нарушения.</li>
            </ul>

            <h3 style={{ marginTop: "20px", marginBottom: "10px", color: "#FFD700" }}>6. Права Администрации</h3>
            <ul style={{ paddingLeft: "18px" }}>
              <li>6.1. Администрация имеет право без предварительного уведомления:
                <ul>
                  <li>удалять любой контент, нарушающий законодательство РФ или условия Соглашения;</li>
                  <li>ограничивать или блокировать доступ Пользователя к сайту;</li>
                  <li>удалять учетные записи Пользователей при выявлении нарушений.</li>
                </ul>
              </li>
              <li>6.2. Администрация вправе изменять функционал сайта, приостанавливать его работу или полностью прекращать предоставление сервиса без объяснения причин.</li>
            </ul>

            <h3 style={{ marginTop: "20px", marginBottom: "10px", color: "#FFD700" }}>7. Обработка персональных данных</h3>
            <ul style={{ paddingLeft: "18px" }}>
              <li>7.1. Пользователь дает согласие на обработку своих персональных данных, предоставленных при использовании сайта.</li>
              <li>7.2. Обработка данных осуществляется исключительно в целях функционирования сервиса.</li>
              <li>7.3. Администрация принимает разумные меры для защиты данных, но не гарантирует абсолютную безопасность.</li>
            </ul>

            <h3 style={{ marginTop: "20px", marginBottom: "10px", color: "#FFD700" }}>8. Изменение условий</h3>
            <ul style={{ paddingLeft: "18px" }}>
              <li>8.1. Администрация вправе в любое время изменять настоящее Соглашение.</li>
              <li>8.2. Актуальная версия Соглашения всегда доступна на сайте.</li>
              <li>8.3. Продолжение использования сайта означает согласие с обновленными условиями.</li>
            </ul>

            <h3 style={{ marginTop: "20px", marginBottom: "10px", color: "#FFD700" }}>9. Заключительные положения</h3>
            <ul style={{ paddingLeft: "18px" }}>
              <li>9.1. Все споры, возникающие в связи с использованием сайта, подлежат разрешению в соответствии с законодательством Российской Федерации.</li>
              <li>9.2. В случае признания отдельных положений недействительными, остальные положения остаются в силе.</li>
            </ul>

            <button
              onClick={() => setLicenseOpen(false)}
              style={{
                marginTop: "20px",
                width: "100%",
                padding: "12px",
                borderRadius: "8px",
                border: "none",
                backgroundColor: "#FFD700",
                color: "#000",
                fontWeight: "bold",
                cursor: "pointer"
              }}
            >
              Закрыть
            </button>
          </div>
        </div>
      )}

    </div>
  );
};

export default RegisterPage;
